<template>
  <Container
    :disable="loading"
    @drop="onDrop"
  >
    <Draggable
      v-for="model in list"
      :key="model.id || model.value || model.key || model"
      style="margin-bottom: -1px"
    >
      <q-item style="border: solid 1px #CCC;">
        <q-item-section avatar>
          <q-icon name="menu" />
        </q-item-section>
        <slot
          name="model"
          :model="model"
        >
          <q-item-section>
            {{ displayField ? model[displayField] : model.name || model.displayName || model.description || $_.startCase(model) }}
          </q-item-section>
        </slot>
      </q-item>
    </Draggable>
  </Container>
  <q-inner-loading
    :showing="loading"
  />
</template>

<script>

import { Container, Draggable } from 'vue3-smooth-dnd'

export default {
  name: 'SetDisplayOrderDialog',
  components: {
    Container,
    Draggable
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    displayField: {
      type: String,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['reorder'],
  methods: {
    onDrop (dropResult) {
      const reorderedList = this.$mh.applyDrag(this.list, dropResult)
      this.$emit('reorder', reorderedList)
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
